import { ensureUsercentricsV3Loaded } from './ensure-usercentrics-v3-loaded';
import type { UsercentricsObject } from './usercentrics.types';

declare global {
  interface Window {
    __ucCmp?: UsercentricsObject;
  }
}

export const openUsercentricsSecondLayer = (
  settingsId?: string
): Promise<void> => {
  if (typeof window === 'undefined') {
    return Promise.resolve();
  }

  if (window.__ucCmp) {
    return window.__ucCmp.showSecondLayer();
  }

  return ensureUsercentricsV3Loaded({ settingsId }).then(() => {
    if (window.__ucCmp) {
      return window.__ucCmp.showSecondLayer();
    }

    return undefined;
  });
};
